import { Grid, Typography } from '@material-ui/core';
import { useRef } from 'react';
import { UseStore } from 'zustand';
import { Text } from '../../core/controls';
import { DateRange } from '../../core/date-time';
import { formApi } from '../../core/form';
import { OrganizationApi } from '../../core/organization-api';
import { LogoutLink, ReportBug } from './navigation';
import { OrganizationSelect } from './organization-select';

export interface PeriodSearch {
  period?: DateRange;
  search?: string;
}

export interface OrganizationSearchHeaderProps {
  title: string | JSX.Element;
  api: UseStore<OrganizationApi>;
  onSearch?: (values: PeriodSearch) => void;
  titleIcon?: any;
  action?: any;
  onLogout?: () => void;
}

export function OrganizationSearchHeader(props: OrganizationSearchHeaderProps) {
  const { title, api, onSearch, titleIcon, action, onLogout } = props;
  const query = useRef(
    formApi({
      values: {
        search: '',
      },
      fields: {
        search: {
          id: 'visit-search-input',
          label: '',
          name: 'search',
          placeholder: 'Type enter to start search',
          onEnter: (search) => onSearch({ search }),
          onClear: () => onSearch({ search: null }),
          clearIcon: true,
          startIcon: 'search',
          style: { width: '240px' },
        },
      },
    })
  ).current;
  const { search } = query.controls;


  return (
    <Grid
      container
      style={{ width: '100%', paddingLeft: '0px', paddingRight: '0px' }}
      direction="row"
      wrap="nowrap"
      spacing={2}
      alignItems="center"
    >
      {titleIcon ? titleIcon : null}
      <Grid item>
        {typeof title === 'string' ? (
          <Typography style={{ paddingRight: '24px' }} variant="h6" noWrap>
            {title}
          </Typography>
        ) : (
          title
        )}
      </Grid>
      {api && (
        <Grid item style={{ padding: 0 }}>
          <OrganizationSelect api={api} direction="horizontal" />
        </Grid>
      )}

      <Grid item style={{ flexGrow: 1 }}></Grid>
      {onSearch && (
        <Grid item style={{ padding: 0 }}>
          <Text {...search} />
        </Grid>
      )}

      {action && (
        <Grid item style={{ padding: 0 }}>
          {action}
        </Grid>
      )}

      <Grid item style={{ padding: 0 }}>
        <ReportBug />
      </Grid>

      <Grid item style={{ paddingLeft: 0, paddingRight: 0 }}>
        <LogoutLink htmlColor="white" onClick={onLogout} />
      </Grid>
    </Grid>
  );
}
